module.exports = __webpack_public_path__ + "static/media/OswaldBold.77ad3db1.woff2";